//framework
import React, { memo } from "react";
import PropTypes from "prop-types";

//styles
import styles from "./ConnectingOverlay.module.scss";

//assets
import { IMAGES } from "constants/constants";

//components
import OutlineText from "components/Shared/OutlineText/OutlineText";

const ConnectingOverlay = memo(function ConnectingOverlay({ show = false, text = "Connecting" }) {
    return (
        <div className={`${styles.overlay} ${show ? styles.show : ""}`} aria-hidden={!show} aria-busy={show} role="status" >
            <div style={{ textAlign: "center" }}>
                <img src={IMAGES.HOST.hostSplash} alt="" aria-hidden="true" />
                <div className={styles.caption}>
                    <OutlineText parentStyles={styles} text={text} className={styles.outlineText} aria-label="Connecting" />
                    <span className={styles.dots} aria-hidden="true">
                        <span className={styles.dot}>.</span>
                        <span className={styles.dot}>.</span>
                        <span className={styles.dot}>.</span>
                    </span>
                </div>
            </div>
        </div> 
    );
});

ConnectingOverlay.propTypes = {
    show: PropTypes.bool.isRequired,
};

export default ConnectingOverlay;
